import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";

export const StickyBar = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 800);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToCTA = () => {
    document.getElementById('final-cta')?.scrollIntoView({ behavior: 'smooth' });
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-void/95 backdrop-blur-md border-t border-blood shadow-[0_-10px_40px_rgba(0,0,0,0.8)] animate-slide-up">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <div className="hidden md:block">
          <p className="text-blood-bright font-bold text-lg uppercase tracking-wide">
            The Discipline Bible
          </p>
          <p className="text-steel text-sm">Limited Pre-Order,  Don't Miss Out</p>
        </div>

        <Button 
          onClick={scrollToCTA}
          className="bg-blood-bright hover:bg-blood text-primary-foreground px-8 py-6 text-lg font-bold uppercase tracking-wider animate-pulse-glow"
        >
          Start the Funeral,  Claim Your Copy
        </Button>
      </div>
    </div>
  );
};
